import {REASON_HANDLER as PREFIX} from '../const';

import {createAction} from './defaults';

export const showReasonHandler = createAction('SHOW_' + PREFIX);
export const closeReasonHandler = createAction('CLOSE_' + PREFIX);